// API service for user management using the actual backend endpoints
import apiClient from './apiClient';

class UsersAPI {

  async signup(email, password) {
    return apiClient.makePublicRequest('/user/signup', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  async login(email, password) {
    return apiClient.makePublicRequest('/user/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  async getUserById(userId) {
    return apiClient.makeAuthenticatedRequest(`/user/${userId}`, {
      method: 'GET',
    });
  }

  async getUserByEmail(email) {
    return apiClient.makeAuthenticatedRequest(`/user/email/${encodeURIComponent(email)}`, {
      method: 'GET',
    });
  }

  async updateUser(userId, userData) {
    return apiClient.makeAuthenticatedRequest(`/user/${userId}`, {
      method: 'PUT',
      body: JSON.stringify(userData),
    });
  }

  async deleteUser(userId) {
    return apiClient.makeAuthenticatedRequest(`/user/${userId}`, {
      method: 'DELETE',
    });
  }

  async getAllUsers(limit = 100, offset = 0) {
    return apiClient.makeAuthenticatedRequest(`/user/?limit=${limit}&offset=${offset}`, {
      method: 'GET',
    });
  }

  async getBasicUserById(userId) {
    return apiClient.makeAuthenticatedRequest(`/user/basic/${encodeURIComponent(userId)}`, {
      method: 'GET',
    });
  }

  async getBasicUserByIdPublic(userId) {
    return apiClient.makePublicRequest(`/user/basic/${encodeURIComponent(userId)}`, {
      method: 'GET',
    });
  }

  async getBasicUserByThreadId(threadId) {
    return apiClient.makePublicRequest(`/user/basic/thread/${encodeURIComponent(threadId)}`, {
      method: 'GET',
    });
  }

  async getUserProfilePublic(userId) {
    return apiClient.makePublicRequest(`/user/${encodeURIComponent(userId)}`, {
      method: 'GET',
    });
  }

  async updateProfilePicture(file) {
    if (file) {
      // Convert file to base64 string
      const base64String = await this.fileToBase64(file);
      
      console.log('Uploading profile picture:', {
        filename: file.name,
        contentType: file.type,
        base64Length: base64String.length
      });
      
      return apiClient.makeAuthenticatedRequest('/user/me/profile-picture', {
        method: 'PUT',
        body: JSON.stringify({
          file: base64String,
          filename: file.name,
          content_type: file.type
        }),
      });
    } else {
      console.log('Removing profile picture');
      
      // When removing profile picture, send null values
      return apiClient.makeAuthenticatedRequest('/user/me/profile-picture', {
        method: 'PUT',
        body: JSON.stringify({
          file: null,
          filename: null,
          content_type: null
        }),
      });
    }
  }

  // Helper method to convert file to base64
  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // Remove the data:image/...;base64, prefix to get just the base64 string
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = error => reject(error);
    });
  }
}

export default new UsersAPI();
